import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";

import {
    setIsDataUpdated as setIsDataUpdatedShops,
    setIsEdited,
} from "../store";
import { store as logo } from "../store";
import { store } from "@components/VerticalLayout/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { editLogo } from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationModificationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsAddLogoClicked: Function;
    isAddLogoClicked: boolean;
    shopId: string[];
    uploadedImage: string | Blob;
    salesSupport: any;
    rowData: any;
    associated: any;
};

export function ConfirmationModificationModal({
    isModalOpened,
    setIsModalOpened,
    setIsAddLogoClicked,
    isAddLogoClicked,
    shopId,
    uploadedImage,
    salesSupport,
    rowData,
    associated,
}: ConfirmationModificationMessageType) {
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { salesSupports, shopsLogoData, editedDataLogo } = useSnapshot(logo);
    const { fetchGlobal } = useFetchGlobal();
    const [isSalesSupportEmpty, setIsSalesSupportEmpty] = useState<boolean[]>(
        []
    );
    const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
    const uuidUser = localStorage.getItem("uuidUser");

    React.useEffect(() => {
        let allLogoShop: any = [];
        let localSalesSupport: boolean[] = [];
        if (shopsLogoData !== undefined) {
            shopsLogoData.forEach((el: any) => {
                if (el.subRows !== undefined)
                    el.subRows.forEach((element: any) => {
                        allLogoShop.push(element.shopId);
                    });
            });
        }
        salesSupports.forEach((el: any) => {
            if (allLogoShop.includes(el.id)) {
                let filteredSalesSupport: any = el.salesSupport.filter(
                    (value: any) => salesSupport.includes(value)
                );
                localSalesSupport.push(
                    filteredSalesSupport.length > 0 &&
                        salesSupport.split(",").length ===
                            filteredSalesSupport.length
                );
            }
            let localData: any = Object.values(editedDataLogo.data)[0];

            setIsDataChanged(
                rowData[t("Designation")] !== localData.designation ||
                    rowData.Image !== localData.urlImage
            );
        });

        setIsSalesSupportEmpty(localSalesSupport);
    }, [
        shopsLogoData,
        salesSupports,
        salesSupport,
        shopId,
        editedDataLogo.data,
        t,
        rowData,
    ]);

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsModalOpened(!isModalOpened)}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        setIsAddLogoClicked(!isAddLogoClicked);
                        setIsEdited(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        editLogo(
                            associated,
                            editedDataLogo,
                            salesSupport,
                            userID,
                            franchiseID,
                            operatorID,
                            uuidUser,
                            rowData,
                            isSalesSupportEmpty,
                            isDataChanged,
                            isAddLogoClicked,
                            setIsAddLogoClicked,
                            setIsDataUpdatedShops,
                            uploadedImage,
                            fetchGlobal
                        );
                        setIsModalOpened(!isModalOpened);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
